import callApi from './callApi';

export const loginUser = async (user) => {
  const url = 'users/sign_in';
  const headers = {
    'Content-Type': 'application/json',
  };
  const body = { user };

  // Directly return the parsed response from callApi
  return await callApi(url, headers, 'POST', body);
};

export const createUser = async (user) => {
  const url = 'users';
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'POST', body);
};

export const activateUser = async (user) => {
  const url = 'users/activate';
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'PUT', body);
};

export const acceptInvite = async (user) => {
  const url = 'users/invite-accepted';
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'PUT', body);
};

export const setUserAccount = async (user) => {
  let url = `users/setup-account`;
  let headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'PUT', body);
};

export const resendEmailLink = async (user) => {
  const url = 'users/resend_link';
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'PUT', body);
};

export const inviteuser = async (user) => {
  const url = 'users/invite';
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'POST', body);
};

export const inviteUsersBulk = async (users) => {
  const url = 'users/bulk-user-invite';
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    users,
  };
  return callApi(url, headers, 'POST', body);
};

export const resendInvites = async (user) => {
  const url = 'users/resend-invite-link';
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'PUT', body);
};

export const listAllUsers = async (perpage, page, search, status, showAssignedProjects = false, selectedProject) => {
  const url = `users?perpage=${perpage || 'all'}&page=${page || 1}&status=${status || 'active'}&search=${search || ''}&showAssignedProjects=${showAssignedProjects}${selectedProject ? `&projectId=${selectedProject}` : ''}`;
  const headers = {
    // 'Content-Type': 'application/json',
  };
  return callApi(url, headers, 'GET');
};

export const fetchCurrentUser = async () => {
  const url = `users/current_user`;
  return await callApi(url, {}, 'GET');
};

export const fetchUserProjectAccess = async () => {
  const url = `users/user-project-access`;
  return await callApi(url, {}, 'GET');
};

export const editUsersAPI = async (user) => {
  let url = `users/update-user`;
  let body = {
    user,
  };
  return callApi(url, {}, 'PUT', body);
};

export const editCurrentUser = async (user) => {
  let url = `users`;
  let body = {
    user,
  };
  // console.log(body);
  return await callApi(url, {}, 'PUT', body);
};

export const updateOrganization = async (org) => {
  let url = `users/update-org`;
  let body = {
    org,
  };
  return await callApi(url, {}, 'PUT', body);
};

export const createContact = async (contactMessage) => {
  let url = `contact_messages`;
  let body = {
    contactMessage,
  };
  return callApi(url, {}, 'POST', body);
};

export const forgotPassword = async (user) => {
  let url = 'users/password';
  let headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    user,
  };
  return callApi(url, headers, 'POST', body);
};

export const resetPassword = async (user) => {
  let url = `users/password`;
  let body = {
    user,
  };
  return callApi(url, {}, 'PUT', body);
};

export const terminateAccount = async (organizationId) => {
  let url = `users/terminate/${organizationId}`;
  let headers = {
    'Content-Type': 'application/json',
  };
  return callApi(url, headers, 'DELETE');
};

export const modifyUserAccountStatus = async (userIds, action) => {
  let url = `users/modify-user-status`;
  let headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    userIds,
    action,
  }
  return callApi(url, headers, 'PUT', body);
};


export const updateUserRole = async (payload, userId) => {
  const url = `users/update-role/${userId}`;
  return callApi(url, {}, 'PUT', payload);
};


export const signOut = async (id) => {
  const url = `users/sign_out`;
  return callApi(url, {}, 'DELETE');
};


export const getJiraAuthUrl = async (integrationType, projectId) => {
  const url = `oauth/jira/url?mode=${integrationType}&projectId=${projectId}`;
  return callApi(url, {}, 'GET');
};

export const connectToJira = async (state, code) => {
  const url = `oauth/jira/callback?state=${state}&code=${code}`;
  return callApi(url, {}, 'GET');
};

export const saveJiraDetails = async (data) => {
  const url = `oauth/jira/save-details`;
  let body = {
    ...data,
  };
  return callApi(url, {}, 'PUT', body);
};

export const fetchCurrentOrganization = async () => {
  const url = `users/organization`;
  return await callApi(url, {}, 'GET');
};

export const getExportRequests = async (organizationId) => {
  const url = `projects/export-data?${organizationId ? `organizationId=${organizationId}&` : ''}`;
  return await callApi(url, {}, 'GET');
};
